import { render, staticRenderFns } from "./CustomerYear.vue?vue&type=template&id=61401221"
import script from "./CustomerYear.vue?vue&type=script&lang=js"
export * from "./CustomerYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports